module.exports = __webpack_public_path__ + "img/ajans-press-courier-ad-05.f2f8e659.jpg";